import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainLayout from "./pages/components/routesLayout/mainLayout.js";
import CleanLayout from "./pages/components/routesLayout/cleanLayout.js";
import ScrollToTop from "./pages/components/scrollTop/index.js";

import Home from "./pages/home/index.js"
import Register from "./pages/register/index.js";
import Login from "./pages/login/index.js";

export default function AppRoutes(){

    return (
        <>
            <BrowserRouter basename="/">
            
            <ScrollToTop/>
            

                <Routes>
                    {/*Páginas com cabeçalho e footer*/}
                    <Route element={<MainLayout/>}> 
                        <Route path="/" element={<Home/>}/>
                    </Route>

                    {/* Páginas sem footer*/ }
                    <Route element={<CleanLayout/>}>
                        <Route path="/register" element={<Register/>}/>
                        <Route path="/login" element={<Login/>}/>
                    </Route>
                </Routes>

            
                
            </BrowserRouter>

        </>
    );
    
}
